export enum PortfolioUserAccess {
    OWNER       = 1,
    STANDARD    = 2,
    FULL        = 3,
}

export const PortfolioAccessLabelDictionary : any = {
    [PortfolioUserAccess.OWNER]     : 'Owner',
    [PortfolioUserAccess.FULL]      : 'Full',
    [PortfolioUserAccess.STANDARD]  : 'Standard',
}

export const PortfolioAccessDescriptionDictionary : any = {
    [PortfolioUserAccess.OWNER]     : '',
    [PortfolioUserAccess.FULL]      : 'Access to all data and management options, suitable for managers.',
    [PortfolioUserAccess.STANDARD]  : 'View all work items but no access to settings or user management.',
}